import { useMemo } from 'react'

import { LoginSource } from '@/consts/team'

import { useAppContext } from './useAppContext'

/**
 * Hook to determine whether the Personal Console option should be visible in the TeamSwitcher
 *
 * Logic:
 * 1. On platform pages → Show if has platform token
 * 2. On team pages → Show if has platform token AND (has bound teams OR switched from platform)
 *
 * @param hasBoundTeams - Whether the user has any bound teams (teams.length > 0)
 * @returns boolean indicating if Personal Console should be shown
 */
export function usePersonalConsoleVisibility(hasBoundTeams: boolean): boolean {
  const { isInPlatform, hasPlatformToken, loginSource } = useAppContext()

  return useMemo(() => {
    if (isInPlatform) {
      // On platform pages: show if has platform token
      return hasPlatformToken
    } else {
      // On team pages: show if has platform token AND (has bound teams OR switched from platform)
      return hasPlatformToken && (hasBoundTeams || loginSource === LoginSource.Platform)
    }
  }, [isInPlatform, hasPlatformToken, hasBoundTeams, loginSource])
}
